import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NgClass } from '@angular/common';

@Component({
	selector: 'formly-section-header',
	template: `
		<div
			class="section-header"
			[ngClass]="props.customClass"
			id="{{ props.id }}"
		>
			<h3 class="section-title">{{ props.label }}</h3>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./section-header.type.scss'],
	imports: [NgClass],
})
export class SectionHeaderType extends FieldType<FieldTypeConfig> {}
